import React, { useEffect, useState } from "react";
import { TopDestinationsData } from "./Data";
import SectionHeading from "../../Common/SectionHeading";
import BigImg from "assets/img/destination/20.jpg";
import { useTranslation } from "react-i18next";
import { Image } from "react-bootstrap";
import { useHotelContext } from "hooks/hotel/useHotelContext";
import { useNavigate } from "react-router-dom";
import useGetHotelAvailability from "hooks/hotel/useGetHotelAvailability";

const TopDestinations = () => {
    const { t } = useTranslation();
    const { setHotelSearchParams, setProviders, hotelSearchParams } =
        useHotelContext();
    const navigate = useNavigate();
    const [startSearch, setStartSearch] = useState(false);
    const { getHotelAvailability } = useGetHotelAvailability();

    const callAvailability = (searchCriteria) => {
        setHotelSearchParams((prev) => {
            return {
                ...prev,
                destination: searchCriteria.destination,
                checkOutDate: searchCriteria.checkOutDate,
                checkInDate: searchCriteria.checkInDate,
            };
        });

        setProviders((prev) => {
            return [...searchCriteria.providers];
        });

        setStartSearch(true);
    };

    const search = async () => {
        navigate("/hotel-search");
        await getHotelAvailability();
        localStorage.setItem("hotelState", JSON.stringify(hotelSearchParams));
        setStartSearch(false);
    };

    useEffect(() => {
        if (startSearch) {
            search();
        }
    }, [startSearch]);

    return (
        <>
            <section id="top_destinations" className="section_padding_top">
                <div className="container">
                    <SectionHeading heading={t("topDestinations")} />
                    <div className="grid grid-cols-1 lg:grid-cols-2 gap-4 h-full">
                        {/* Left side - Big image */}
                        <div className="relative group h-full rounded-[14px] overflow-hidden">
                            <Image 
                                loading="lazy" 
                                src={BigImg} 
                                alt="img" 
                                className="w-full h-full object-cover min-h-[400px]"  
                            />
                            <div className="destinations_content_inner group-hover:text-white">
                                <h2>{t("upTo")}</h2>
                                <div className="destinations_big_offer">
                                    <h1>50</h1>
                                    <h6>
                                        <span>%</span> <span>{t("off")}</span>
                                    </h6>
                                </div>
                            </div>
                        </div>
                        
                        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4 h-full">
                            {TopDestinationsData.map((data) => (
                                <div
                                    className="relative group rounded-[14px] overflow-hidden cursor-pointer h-full"
                                    key={data.id}
                                    onClick={() => {
                                        callAvailability(data.search_criteria);
                                    }}
                                >
                                    <Image
                                        loading="lazy"
                                        src={data.img}
                                        alt="img"
                                        className="object-cover w-full h-full min-h-[200px] destination-card"
                                    />
                                    <div className="absolute bottom-0 left-0 right-0 bg-gradient-to-t from-black/80 to-transparent p-4">
                                        <h3 className="text-white text-[20px] md:text-[16px] font-semibold truncate">
                                            {data.heading || t("visitNow")}
                                        </h3>
                                    </div>
                                </div>
                            ))}
                        </div>
                    </div>
                </div>
            </section>
        </>
    );
};

export default TopDestinations;